module.exports = __webpack_public_path__ + "412df790f146c0d6b0e5d59e678ea5d2.MP3";